import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSelect } from '@angular/material/select';
import { MatSort } from '@angular/material/sort';
import { Router } from '@angular/router';
import { merge } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AlertsCenterService } from 'src/app/core/services/alerts-center.service';
import { DialogService } from 'src/app/services/dialog.service';
import { EventiDataSource } from 'src/app/services/eventi.datasource';
import { EventiService } from 'src/app/services/eventi.service';
import { RichiesteDgpeService } from 'src/app/services/richieste-dgpe.service';

@Component({
  selector: 'app-selezione-dpgr-dialog',
  templateUrl: './selezione-dpgr-dialog.component.html',
  styleUrls: ['./selezione-dpgr-dialog.component.css']
})
export class SelezioneDpgrDialogComponent implements OnInit {

  arrowFlag: boolean = false;
  dettaglio: boolean = false;
  eventDetail: any;
  risultatiPerPagina: number = 5;
  public form: FormGroup;
  controlList: ModelEventiCalamitosi.EventoDto[] = [];
  aggiungiTutti: string = "";
  private filtrato: boolean = false;
  dataSource: EventiDataSource;
  confirmed: string;
  private filtroRicerca: string = "";
  eventiSearchableDto: ModelEventiCalamitosi.EventiSearchableDto = {
    idEvento: null,
    dpgr: null,
    descrizione: null,
    stato: null,
    attiAmmiComm: null,
    ocdpc: null,
    dataEventoDa: null,
    dataEventoA: null,
    primaDataChiusuraRaccolta: null,
    dataEvento: null,
    inviato: null,
  };

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('orderBy') orderBy: MatSelect;


  isLoading: boolean = false;
  openToggle: number = 0;
  ocdpc: string = '';
  flagTableEmpty: boolean = false;

  constructor(
    private eventiService: EventiService,
    private richiesteService: RichiesteDgpeService,
    private router: Router,
    private alertsCenterService: AlertsCenterService,
    private dialogRef: MatDialogRef<SelezioneDpgrDialogComponent>,
    private selezioneDpgrDialogSvc: DialogService,
    @Inject(MAT_DIALOG_DATA) data) {
    dialogRef.disableClose = true;
    this.buildForm();
    this.ocdpc = data.ocdpc;
    this.flagTableEmpty = data.listaDpgrEmpty;
  }

  ngOnInit(): void {
    this.dataSource = new EventiDataSource(this.eventiService);
    this.dataSource.errors$.subscribe(res => {
      if (res) this.alertsCenterService.showAlert({
        message: `Errore lettura dati`,
        type: 'danger',
        autoClosable: false
      });
    })
    //
  }

  displayedColumns: string[] = ['dpgr', 'denominazione', 'dataEvento', 'aggiungi'];

  ngAfterViewInit() {
    setTimeout(() => {

      this.dataSource.loadDpgrDaAssociare('', this.controlList, this.aggiungiTutti, this.eventiSearchableDto, 'dataEvento,DESC', 0, this.risultatiPerPagina);

      this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

      merge(this.sort.sortChange, this.paginator.page)
        .pipe(
          tap(() => {
            this.ricercaListaEventi();
          }))
        .subscribe();

      this.dataSource.counter$
        .pipe(
          tap((count) => {
            this.paginator.length = count;
          })
        )
        .subscribe();
    });
  }

  private buildForm() {
    this.form = new FormGroup({
      filtro: new FormControl(null, null),
    });
  }

  public ricercaListaEventi(filtrato?: boolean): void {

    if (filtrato) {
      this.filtrato = true;
      this.filtroRicerca = this.form.controls.filtro.value;
    }


    if (this.filtroRicerca != '') {
      this.eventiSearchableDto = {
        idEvento: null,
        descrizione: this.filtroRicerca,
        dpgr: this.filtroRicerca,
        dataEventoA: null,
        dataEventoDa: null,
        dataEvento: this.filtroRicerca,
        primaDataChiusuraRaccolta: null,
        stato: null
      }
    } else {
      this.eventiSearchableDto = {
        idEvento: null,
        descrizione: this.form.controls.filtro.value ? this.form.controls.filtro.value : null,
        dpgr: this.form.controls.filtro.value ? this.form.controls.filtro.value : null,
        dataEventoA: null,
        dataEventoDa: null,
        dataEvento: this.form.controls.filtro.value ? this.form.controls.filtro.value : null,
        primaDataChiusuraRaccolta: null,
        stato: null
      }
    }

    this.dataSource.loadDpgrDaAssociare('', this.controlList, this.aggiungiTutti, this.eventiSearchableDto, this.sort.active + "," + this.sort.direction, this.paginator.pageIndex, this.paginator.pageSize);
  }

  sendDpgr(dpgr) {
    let present = false;
    this.controlList.forEach((element, index) => {
      if (element.idEvento === dpgr.idEvento) {
        this.controlList.splice(index, 1);
        present = true;
      }
    });
    if (!present) this.controlList.push(dpgr);
  }

  setAll(checked) {
    if (checked === true) {
      this.aggiungiTutti = 'S'
    } else {
      this.aggiungiTutti = ""
    }

    if (this.filtrato) {
      if (this.filtroRicerca != '') {
        this.eventiSearchableDto = {
          idEvento: null,
          descrizione: this.filtroRicerca,
          dpgr: this.filtroRicerca,
          dataEventoA: null,
          dataEventoDa: null,
          dataEvento: this.filtroRicerca,
          primaDataChiusuraRaccolta: null,
          stato: null
        }
      } else {
        this.eventiSearchableDto = {
          idEvento: null,
          descrizione: this.form.controls.filtro.value ? this.form.controls.filtro.value : null,
          dpgr: this.form.controls.filtro.value ? this.form.controls.filtro.value : null,
          dataEventoA: null,
          dataEventoDa: null,
          dataEvento: this.form.controls.filtro.value ? this.form.controls.filtro.value : null,
          primaDataChiusuraRaccolta: null,
          stato: null
        }
      }
    } else {
      this.eventiSearchableDto = {
        idEvento: null,
        descrizione: null,
        dpgr: null,
        dataEventoA: null,
        dataEventoDa: null,
        dataEvento: null,
        primaDataChiusuraRaccolta: null,
        stato: null
      }
    }

    this.controlList = []
    this.dataSource.loadDpgrDaAssociare('', this.controlList, this.aggiungiTutti, this.eventiSearchableDto, this.sort.active + "," + this.sort.direction, this.paginator.pageIndex, this.paginator.pageSize)
  }

  onReset() {
    this.form.reset();
    this.eventiSearchableDto = {
      idEvento: null,
      descrizione: null,
      dpgr: null,
      dataEventoA: null,
      dataEventoDa: null,
      dataEvento: null,
      primaDataChiusuraRaccolta: null,
      stato: null
    };
    this.filtrato = false;
    this.aggiungiTutti = "";
    this.filtroRicerca = '';
    this.controlList = [];
    this.dataSource.loadDpgrDaAssociare('', this.controlList, this.aggiungiTutti, this.eventiSearchableDto, 'dataEvento,DESC', 0, this.risultatiPerPagina);
  }

  openAggiungiDpgrDialogConfirm() {
    if ((this.aggiungiTutti === '' && this.controlList.length === 0) || this.dataSource.counter$.source['value'] === 0) {
      this.alertsCenterService.showAlert({
        message: 'Selezionare almeno un DPGR',
        type: 'danger',
        autoClosable: false,
      });
    } else if(this.flagTableEmpty) {
      let title = 'Aggiungi DPGR';
      let message = "Vuoi davvero aggiungere DPGR a questa richiesta? \n"
      let adv =  "Associando anche un solo dpgr ad un ocpdc non sarà più possibile eliminare l'ocdpc";
      message += adv.bold();
      this.selezioneDpgrDialogSvc.openDialog(title, message).subscribe(
        result => {
          this.confirmed = `${result}`;
          if (this.confirmed == "true") {
            this.aggiungiDpgr();
          }
        }
      );
    } else {
      let title = 'Aggiungi DPGR';
      let message = 'Vuoi davvero aggiungere DPGR a questa richiesta?'
      this.selezioneDpgrDialogSvc.openDialog(title, message).subscribe(
        result => {
          this.confirmed = `${result}`;
          if (this.confirmed == "true") {
            this.aggiungiDpgr();
          }
        }
      );
    }
  }

  aggiungiDpgr() {
    this.richiesteService.aggiungiDpgr(this.ocdpc, this.controlList, this.aggiungiTutti, this.eventiSearchableDto,).subscribe(res => {
      this.aggiungiTutti = "";
      this.controlList = [];
      this.filtroRicerca = '';
      this.filtrato = false;
      this.alertsCenterService.showAlert({
        message: 'Lista DPGR associati aggiornata con successo',
        type: 'success',
        autoClosable: false
      });
    },
      err => {
        this.alertsCenterService.showAlert({
          message: err.error.esitoServizio.descrizioneEsito,
          type: 'danger',
          autoClosable: false
        });
      },
      () => {
        this.dialogRef.close(true);
      });
  }

  private isGoodDate(dt) {
    let dateReg = /^\d{2}([./-])\d{2}\1\d{4}$/
    return dateReg.test(dt);
  }
}
